import React, { useState } from "react"
import PropTypes from "prop-types"
import { Box, Typography } from "@carrotfertility/carotene-core"
import { FormattedMessage } from "react-intl"
import { useDidMount } from "../../../utils/Hooks"
import { MerchantDeclineLoading } from "./MerchantDeclineLoading"
import { useHistory, useParams } from "react-router-dom"
import { carrotClient } from "#/utils/CarrotClient"

const defaultState = {
  isLoading: true
}

export const MerchantApproved = () => {
  // @ts-expect-error TS(2339) FIXME: Property 'token' does not exist on type '{}'.
  const { token } = useParams()
  const [state, setState] = useState(defaultState)
  const history = useHistory()

  useDidMount(() => {
    const approveMerchant = async () => {
      try {
        await carrotClient.approveMerchant(token)
        setState({
          ...state,
          isLoading: false
        })
      } catch {
        history.push("/confirm/error")
      }
    }

    approveMerchant().then()
  })
  return state.isLoading ? (
    <MerchantDeclineLoading />
  ) : (
    <>
      <Box sx={(theme) => ({ marginBlockStart: theme.tokens.spacing.xl })}>
        <Typography variant="h3">
          <FormattedMessage defaultMessage="Thanks for confirming" />
        </Typography>
      </Box>
      <Box sx={(theme) => ({ marginBlockStart: theme.tokens.spacing.md })}>
        <Typography>
          <FormattedMessage defaultMessage="Your Carrot Card should now work with this provider — please try again." />
        </Typography>
      </Box>
    </>
  )
}

MerchantApproved.propTypes = {
  token: PropTypes.string
}
